import React, { useEffect, useState } from 'react'
import { Dialog, DialogContent, Typography, makeStyles } from '@material-ui/core'
import HolidayForm from './HolidayForm'
import { HolidayRequest, useSettingHoliday } from '../../../services/um/useSettingHoliday'
import useLoading from '../../../control/loading/useLoading'
import useTranslate from '../../../i18n/useTranslate'
import DuplicateHolidayDialog from './DuplicateHolidayDialog'

type Props = {
    open: boolean
    onCancel: () => void
    onSuccess: () => void
}

const HolidayCreateDialog: React.FC<Props> = ({ open, onCancel, onSuccess }) => {
    const classes = useStyles()
    const translate = useTranslate()
    const { upsertHolidaySetting } = useSettingHoliday()

    const [value, setValue] = useState<HolidayRequest>({})
    const [duplicateOpen, setDuplicateOpen] = useState(false)

    const loadingHook = useLoading()

    const handleSubmit = async (newValue: HolidayRequest) => {
        loadingHook.loadingOpen()
        try {
            const res = await upsertHolidaySetting(newValue)
            if (res.message === 'DUPLICATE DATE') {
                setDuplicateOpen(true)
                return
            }
            onSuccess()
        } finally {
            loadingHook.loadingClose()
        }
    }

    useEffect(() => {
        if (!open) {
            setValue({})
        }
    }, [open])

    return (
        <>
            <Dialog open={open} onClose={onCancel} fullWidth maxWidth="sm">
                <Typography variant="h6" className={classes.header}>
                    {translate.get('UM.SETTING_HOLIDAY.ADD_HOLIDAY')}
                </Typography>

                <DialogContent className={classes.content}>
                    <HolidayForm value={value} onChange={(e) => handleSubmit(e)} onCancel={onCancel} />
                </DialogContent>
            </Dialog>

            <DuplicateHolidayDialog open={duplicateOpen} onClose={() => setDuplicateOpen(false)} />
        </>
    )
}

const useStyles = makeStyles((theme) => ({
    header: { background: '#DB5F8E', color: '#fff', padding: theme.spacing(2), fontWeight: 700 },
    content: { display: 'flex', justifyContent: 'center', padding: 20 },
}))

export default HolidayCreateDialog
